import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { RecordController } from 'src/controllers/record.controller'
import { PendingRecordListDTO } from 'src/dto/record.dto'
import { usePermissions } from 'src/hooks/auth/usePermissions'
import { GetPendingRecordListParams } from 'src/services/api/record.service'

const recordController = new RecordController()

export function useGetPendingRecordList(params: GetPendingRecordListParams = {}, scope = 'get-pending-records') {
  const { userFarm: farmId } = useAuth()
  const { isAdmin, isManager } = usePermissions()
  const itemPerPage = 19

  return useInfiniteQuery<PendingRecordListDTO, Error>({
    queryKey: [scope, params],
    queryFn: async ({ pageParam = 1 }) => {
      return recordController.getPendingRecordList(farmId!, {
        ...params,
        tokenPage: pageParam as string,
        itemPerPage
      })
    },
    initialPageParam: null,
    enabled: !!farmId && !!(isAdmin || isManager),
    refetchOnMount: true,
    staleTime: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage && lastPage.list.length > 0 && lastPage.list.length === itemPerPage) {
        return String(allPages.length + 1)
      }
      return undefined
    }
  })
}
